import { Logger } from '@deqo/foundation';

const errLog = Logger.get('app.errors');

export class ImageInfo {

    public static load(url: string) {
        return new Promise<ImageInfo>((rs, rj) => {
            const img = new Image();
            img.onload = () => rs(new ImageInfo(url, img.width, img.height));
            img.onerror = e => {
                errLog.error(e);
                rj(e);
            };
            img.src = url;
        });
    }

    constructor(
        public readonly url: string,
        public readonly width: number,
        public readonly height: number) {
    }
}
